// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  browseButton: 'Choose file...'
};